<div class="row container-banner-secretaria-trabajo sep-container">
	<div class="col-8 col-md-7">
		<p>
			Manpower puede desarrollar cualquier contenido <br class="d-none d-sm-block">a nivel oficial con la aprobación de la SEP.
		</p>
	</div>

	<div class="col-4 col-md-3">
		<img src="assets/img/sep.png" class="img-fluid">
	</div>
</div>